import { useState, useEffect } from "react";
import HeaderWeeklyCalendar from "./ScheduleHeader";
import { Grid } from "@mui/material";
import WeeklyCalendar from "./Calendar/WeeklyCalendar";

import AddCalendarEventModal from "../CalendarForms/Add-Calendar-Event-Modal";

import EditMenuModal from "./Edit-Menu-Modal";
import SidebarCalendar from "./Sidebar-Calendar";

import { useSelector } from "react-redux";
import {
  deleteEvent,
  filterEventsType,
  loadEvents,
  loadWorkTypes,
} from "../../redux/actions/schedule.actions";
import { storeStateType, useAppDispatch } from "../../redux/store";
import AssignEmployeeModal from "./Assign-Employee-Modal";
import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";
import { IPeople } from "../../redux/reducers/people.reducer";
import MonthlyCalendar from "../MonthlyCalendar/MonthlyCalendar";
import { SAVE_NOT } from "../../redux/types/schedule.types";
import WithPermission from "../../components/WithPermission";
import {
  IFacilityOption,
  eventForm,
} from "../CalendarForms/Types/calendarTypes";

export default function NewSchedule() {
  const [selectedFacility, setSelectedFacility] =
    useState<null | IFacilityOption>(null);
  const [overallDate, setOverallDate] = useState<string>(new Date().toString());

  //for showing event form modal
  const [showingEventForm, setShowingEventForm] = useState<eventForm>({
    visible: false,
  });

  // for switching monthly and weekly calendar
  const [calendarType, setCalendarType] = useState<"weekly" | "monthly">(
    "weekly"
  );

  //for showing edit menu modal
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  //for clicked event
  const [selectedEvent, setSelectedEvent] = useState<IScheduleEvent | null>(
    null
  );

  //for assigned employee
  const [assignedEmployee, setAssignedEmployee] = useState<IPeople[]>([]);

  const [filterByWorktype, setFilterByWorktype] = useState<string[]>([]);
  const [filterEvents, setFilterEvents] = useState<filterEventsType>({
    start_date: "",
    end_date: "",
  });

  //employee for event
  const [showAssignEmployeeModal, setShowAssignEmployeeModal] =
    useState<boolean>(false);

  const { save } = useSelector((state: storeStateType) => state.schedule);

  const dispatch = useAppDispatch();

  useEffect(() => {
    setFilterEvents((preState: filterEventsType) => {
      return { ...preState, facility: selectedFacility?.id };
    });
  }, [selectedFacility]);

  // getWorkfield list
  useEffect(() => {
    dispatch(loadWorkTypes());
  }, [dispatch]);
  useEffect(() => {
    let timerKey: any;

    timerKey = setTimeout(() => {
      if (filterEvents.start_date) dispatch(loadEvents(filterEvents));
    }, 500);

    return () => {
      clearInterval(timerKey);
    };
  }, [filterEvents, dispatch]);

  useEffect(() => {
    let timerKey: any;
    if (save) {
      setShowingEventForm({ visible: false });
      setShowEditModal(false);
      setShowAssignEmployeeModal(false);
      dispatch({ type: SAVE_NOT });
    }

    return () => {
      clearInterval(timerKey);
    };
  }, [save, dispatch]);

  const allEvents: IScheduleEvent[] = useSelector(
    (state: storeStateType) => state.schedule.events
  );

  //hit server for getting schedule events

  function handleDeleteEvent() {
    dispatch(deleteEvent(selectedEvent?.id ?? ""));
  }

  type assignedEmployeeListType = {
    ids: string[];
    employees: any[];
  };
  // for getting assigned employees in events
  useEffect(() => {
    let assignedEmployee: assignedEmployeeListType = { ids: [], employees: [] };
    allEvents.map((event) => {
      if (event.assigned_to) {
        if (!assignedEmployee.ids.includes(event?.assigned_to?.id)) {
          assignedEmployee.ids.push(event?.assigned_to?.id);
          assignedEmployee.employees.push(event?.assigned_to);
        }
      }
      return null;
    });
    setAssignedEmployee(assignedEmployee.employees);
  }, [allEvents]);

  return (
    <>
      <WithPermission
        roleReqiured={["ADMIN", "STAFF", "USER"]}
        message="Access Denied"
      >
        <Grid container className="weekly-calendar-container">
          <Grid item xs={12}>
            <HeaderWeeklyCalendar
              setSelectedFacility={setSelectedFacility}
              overallDate={overallDate}
              setOverallDate={setOverallDate}
              setFilterByWorktype={setFilterByWorktype}
              setFilterEvents={setFilterEvents}
              setCalendarType={setCalendarType}
              calendarType={calendarType}
              filterEvents={filterEvents}
            />
          </Grid>
          <Grid container>
            <Grid
              item
              mt={3}
              lg={2}
              sm={12}
              xs={12}
              paddingRight={1}
              className="sidebar"
            >
              <SidebarCalendar assignedEmployee={assignedEmployee} />
            </Grid>
            <Grid item mt={3} lg={10} sm={12} xs={12}>
              {calendarType === "weekly" && (
                <WeeklyCalendar
                  overallSelectedDate={overallDate}
                  selectedFacility={selectedFacility}
                  setFilterEvents={setFilterEvents}
                  setShowingEventForm={setShowingEventForm}
                  allEvents={allEvents}
                  setShowEditModal={setShowEditModal}
                  setSelectedEvent={setSelectedEvent}
                  filterByWorktype={filterByWorktype}
                  setShowAssignEmployeeModal={setShowAssignEmployeeModal}
                />
              )}

              {calendarType === "monthly" && (
                <MonthlyCalendar
                  overallSelectedDate={overallDate}
                  selectedFacility={selectedFacility}
                  setFilterEvents={setFilterEvents}
                  setShowingEventForm={setShowingEventForm}
                  allEvents={allEvents}
                  setShowEditModal={setShowEditModal}
                  setSelectedEvent={setSelectedEvent}
                  filterByWorktype={filterByWorktype}
                  setShowAssignEmployeeModal={setShowAssignEmployeeModal}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </WithPermission>

      {/* modals here */}
      {showEditModal && (
        <EditMenuModal
          titleName={`Schedule`}
          setShowEditModal={setShowEditModal}
          setShowingEventForm={setShowingEventForm}
          handleDeleteEvent={handleDeleteEvent}
          setSelectedEvent={setSelectedEvent}
          setShowAssignEmployeeModal={setShowAssignEmployeeModal}
          selectedEvent={selectedEvent}
        />
      )}

      {showingEventForm?.visible && (
        <AddCalendarEventModal
          titleName={`Schedule`}
          showingEventForm={showingEventForm}
          setShowingEventForm={setShowingEventForm}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          overallDate={overallDate}
          selectedFacility={selectedFacility}
          filterEvents={filterEvents}
        />
      )}

      {showAssignEmployeeModal && (
        <AssignEmployeeModal
          titleName={`Assign Employee`}
          setShowAssignEmployeeModal={setShowAssignEmployeeModal}
        />
      )}
    </>
  );
}
